import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Observable} from 'rxjs';
import { filter, first, map } from 'rxjs/operators';
import { UserContextService } from '../core/services/user-context.service';
import { InstanceProviderService } from './instance-provider.service';


export const InstanceCheckGuard: CanActivateFn = (route, state): Observable<boolean> => {
  // Inject the required services
  const userContextService = inject(UserContextService);
  const instanceProvider = inject(InstanceProviderService);

  return instanceProvider.isInstanceLoaded$.pipe(
    first(),
    map((loaded) => {
      if (loaded === 'loaded') {
        const instance = userContextService.CurrentInstance;
        return !!instance?.ID; // Allow or deny activation based on instance existence        
      }
      else {
        return true; // while loading we can show stuff because it is just a spinning loaded status
      }
    })
  );
};
